export default __webpack_public_path__ + "static/media/adoration_of_the_shepherds_cc_img.749f0600.jpg";